import React from 'react';
import './Offers.css';

const Offers = () => {
  return (
    <section className="offers">
      <div className="offers__container">
        <div className="offers__header">
          <h2 className="offers__title">Offers</h2>
          <p className="offers__subtitle">
            Promotions, deals, and special offers for you.
          </p>
        </div>
        
        <div className="offers__card">
          <div className="offers__card-content">
            <div className="offers__card-text">
              <h3 className="offers__card-title">Discover great stays</h3>
              <p className="offers__card-offer">Hand-picked stays for every kind of trip</p>
              <p className="offers__card-description">
                Browse hotels and vacation homes in popular cities and coastal spots. Compare options,
                read what matters to you, and plan a trip that fits your style—without pressure or
                fixed booking windows.
              </p>
            </div>
            <div className="offers__card-image-wrapper">
              <img 
                src="https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=600&h=600&fit=crop" 
                alt="Hotel and resort stay"
                className="offers__card-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offers;
